import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "@/services/store";
import { BaseMobileHeader } from "@/common/AppMobileHeader";
import { deleteWidgetById } from "../../../slice";
import { getWidgetContent, MobileWidgetsArray } from "../../../constants";
import { GridItem } from "../../GridItem";
import styles from "../styles.module.scss";

export const GridMobile = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const widgets = MobileWidgetsArray;

  const itemRefs = useRef<HTMLDivElement[]>([]);
  const [containerHeights, setContainerHeights] = useState<number[]>([]);

  useEffect(() => {
    const heights = itemRefs.current.map((ref) => (ref ? ref.clientHeight : 0));
    setContainerHeights(heights);
  }, []);

  const handleDelete = (key: string) => {
    dispatch(deleteWidgetById(key));
  };

  return (
    <div className={styles["root"]}>
      <div className={styles["header"]}>
        <BaseMobileHeader title={t("common.dashboard")} />
      </div>
      <div className={styles.root}>
        {widgets?.map((widget, index) => {
          const currentWidget = getWidgetContent({
            widgetContentId: widget.widgetContentId,
            containerHeight: containerHeights[index],
          });
          return (
            <div className={classNames(styles["grid-item"])} key={index}>
              <GridItem
                currentWidget={currentWidget}
                handleDelete={handleDelete}
                index={index}
                itemRefs={itemRefs}
                widget={widget}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
